import { __assign, __extends } from "tslib";
import React from 'react';
import get from 'lodash/get';
import { withTranslation, Trans } from 'react-i18next';
import { NotificationType } from '../../Notifications/redux/types';
import Notification from '../../Notifications/Notification';
import AddToFaveIcon from '../../Icons/AddedToFav';
import RemoveFaveIcon from '../../Icons/RemovedFromFav';
import ErrorIcon from '../../Icons/CloseBold';
import { BiDataHook, BiEventType } from '../../biLogger';
import { getDeviationResourceType } from '../../DeviationViews/_helpers';
import { getDeviationNotificationQueue } from '../../DeviationPage/redux/helpers';
var FaveNotification = /** @class */ (function (_super) {
    __extends(FaveNotification, _super);
    function FaveNotification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onUndo = function () {
            var _a = _this.props, deviation = _a.deviation, isFavourite = _a.isFavourite, removeNotification = _a.removeNotification, id = _a.id, queueName = _a.queueName;
            _this.isUndoable() && _this.props.onUndo(deviation, !isFavourite, queueName);
            removeNotification(id);
        };
        _this.onCollect = function () {
            var _a = _this.props, deviation = _a.deviation, removeNotification = _a.removeNotification, id = _a.id, queueName = _a.queueName;
            _this.props.onAddToCollection &&
                _this.props.onAddToCollection(deviation, queueName);
            removeNotification(id);
        };
        return _this;
    }
    FaveNotification.prototype.render = function () {
        var _a = this.props, success = _a.success, id = _a.id, t = _a.t, isFavourite = _a.isFavourite, deviation = _a.deviation, queueName = _a.queueName, addNotification = _a.addNotification;
        var deviationBiData = {
            itemid: deviation.deviationId,
            typeid: getDeviationResourceType(deviation),
            creatorid: get(deviation, 'author.useridUuid'),
        };
        return (React.createElement(Notification, { id: id, queueName: queueName, iconComponent: success
                ? this.isUndo() || !isFavourite
                    ? RemoveFaveIcon
                    : AddToFaveIcon
                : ErrorIcon, backgroundDeviation: deviation, actions: [
                success &&
                    !this.isUndo() &&
                    isFavourite && {
                    type: 'negative',
                    label: t('faveNotification.notification.action.undo'),
                    biData: __assign({ evid: BiEventType.POPUP_CLICK_UNDO_FAVE }, deviationBiData),
                    onClick: this.onUndo,
                },
                !this.isUndo() &&
                    isFavourite && {
                    type: 'positive',
                    label: t('faveNotification.notification.action.addToCollection'),
                    biData: __assign({ evid: BiEventType.POPUP_CLICK_ADD_TO_COLLECTION }, deviationBiData),
                    onClick: this.onCollect,
                },
            ], dataHook: BiDataHook.FAVES_POPUP, onClose: queueName === getDeviationNotificationQueue(deviation) &&
                success &&
                isFavourite &&
                !this.isUndo()
                ? function () { return addNotification(queueName, 'commentReminder', {}); }
                : undefined },
            React.createElement("span", { "data-hook": BiDataHook.FAVES_POPUP_MESSAGE }, this.renderTitle())));
    };
    FaveNotification.prototype.renderTitle = function () {
        var _a = this.props, success = _a.success, t = _a.t, isFavourite = _a.isFavourite;
        var wasRemoved = this.isUndo() || !isFavourite;
        if (!success) {
            return t("faveNotification.error." + (wasRemoved ? 'removedFromFaves' : 'addedToFaves') + ".v2");
        }
        if (wasRemoved) {
            return (
            // prettier-ignore
            React.createElement(Trans, { i18nKey: "faveNotification.notification.removedFromFaves.v2" },
                "Removed from ",
                React.createElement("b", null, "Favourites")));
        }
        return (
        // prettier-ignore
        React.createElement(Trans, { i18nKey: "faveNotification.notification.addedToFaves.v2" },
            "Added to ",
            React.createElement("b", null, "Favourites")));
    };
    FaveNotification.prototype.isUndo = function () {
        return this.props.type === NotificationType.FaveUndo;
    };
    FaveNotification.prototype.isUndoable = function () {
        return !this.isUndo();
    };
    return FaveNotification;
}(React.Component));
export { FaveNotification };
export default withTranslation()(FaveNotification);
//# sourceMappingURL=FaveNotification.js.map